import { ApiResponseError } from 'shared/services/RestService';

// The save call suppresses the app-wide toast, so the refusals meant for the
// advisor keep their backend text: 403 not the latest portfolio, 409 already
// saved, 422 only insurance policies. Anything else gets the generic text.
const ADVISOR_REFUSALS = new Set([403, 409, 422]);

export const saveErrorMessage = (error: unknown, fallback: string): string =>
  error instanceof ApiResponseError && ADVISOR_REFUSALS.has(error.status) ? error.message : fallback;
